module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA7"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.8.0.0.box.558.551.460.53.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.8.0.0.box.558.551.460.53.q.90"
    }
  }, [_vm._v("FOREWORD")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.8.1.0.box.190.892.1199.1232.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.8.1.0.box.191.892.1194.370.q.60"
    }
  }, [_c('b', [_vm._v("T")]), _vm._v("O SAY that this is a "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("good ")]), _vm._v("book is to say nothing. To advise one to read it for entertainment is a sacrilege. To urge its reading for information, or even for inspiration, is to reveal a lack of insight. This book is a revelation of hell on earth, of the existence of a malignant wickedness and evil in this world. If any man can read it and not be stirred to his depths, it is because he has no depths.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.1.1.box.191.1272.1194.260.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.1.0"
    }
  }), _vm._v("The author passed through the most degrading and awful experiences imaginable, but emerged unscathed to write his story with the coolness of a reporter staring facts—facts so terrible that they need no interpretation or embellishment. Their mere statement is their own ghastly condemnation.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.1.2.box.190.1542.1199.582.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.2.0"
    }
  }), _vm._v("I read the book at one sitting. I could not put it down, save occasionally to recover myself. Stories are related of such sublime faith and Christlikeness of spirit that one is awed, as one's eyes fill with tears. We Christians who occasionally suffer a little difficulty will be ashamed, on reading this book, of complaining of our \"light afflictions.\" This man Niemoeller is drawn by Stein as a man touched by the splendor of God. One is convinced that Niemoeller will rank among the great martyrs of the faith. He will give new life to religion, for he actually has demonstrated what we preach, that one can through prayer and faith overcome anything in"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.9.1.0.box.202.293.1192.208.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.0.0"
    }
  }), _vm._v("\nthis world. When the war is over and history records this period of time, it is not impossible that the greatest name, a name to inspire men for years to come, will be that of the magnificent Christian, Martin Niemoeller.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.9.1.0.box.192.293.1206.1835.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.9.1.1.box.200.512.1194.640.q.60"
    }
  }, [_vm._v("Occasionally we hear people say that the Church should have nothing to do with this war. We all hate war. As Christians, how could we do otherwise? After reading this book, however, if we have not previously realized it, we will be convinced that there is an evil more virulent even than war, and against that evil we must set our face. We must do more than admire Niemoeller and pay tribute to his greatness. The evil thing against which he fights must be destroyed. This demon must be exorcised from human society. We frequently talk about loving our Christian brothers in all lands, and we do love them; but how can we love them and not do all in our power to set them free?")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.9.1.2.box.199.1162.1194.315.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.2.0"
    }
  }), _vm._v("Personally, I would give almost anything if I could have the privilege some happy day of walking into that German concentration camp, straight up to Niemoeller, and saying, \"My brother in Christ, the Nazi evil is no more. With God's help, we destroyed it. Come back, Martin Niemoeller, to your old pulpit, and preach with no let or hindrance.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.9.1.3.box.192.1487.1202.412.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.3.0"
    }
  }), _vm._v("To behold that saint, white of hair, emaciated of body, as a result of his suffering, as he would climb the pulpit stair in a great free Germany, and to think that I in even a small way had helped to make it possible, would give me the deepest joy I can imagine. Never forget, also, that there are many others like Niemoeller, Catholic, Protestant and Jew, and thousands of fine German people who undramatically feel in their hearts as he does.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.9.1.4.box.200.1922.1198.206.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.4.0"
    }
  }), _vm._v("If in giving my support to war, which is the means for making this great freedom possible, I am guilty of sin, then I believe that the same understanding Heavenly Father (who can unravel all dilemmas), who has often forgiven me of"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.10.1.0.box.193.292.1191.307.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.0.0"
    }
  }), _vm._v("\nother sins, will absolve me of this one, also. As a Christian I must fight against wickedness. I can do so without hate. On the contrary, I can do so with a great sense of love, because I am struggling for something that is of the best in men, the death of which would mean tragedy indescribable. I believe that God sees me in this dilemma and understands.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.10.1.0.box.191.292.1199.903.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.1.1.box.191.622.1199.422.q.60"
    }
  }, [_vm._v("It must also be stated that only a great soul could have written this book. Dr. Stein also suffered, but he says little of his own sufferings. He writes with no hate. He writes simply, calmly; and perhaps for that reason as well as because of the subject matter the book has dramatic power. Dr. Stein suffered, but I believe he would say it was worth it to have lived with one of the world's immortal figures in a supreme event of history.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.1.2.box.191.1055.1193.140.q.60"
    }
  }, [_vm._v("This book should go throughout the world, like the bugle call which it is, summoning men to stand for their faith—the faith which sets men free.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.10.2.0.box.192.1272.1192.86.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.10.2.0.box.920.1272.464.32.q.90"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.3.0"
    }
  }), _vm._v("Norman ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Vincent ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Peale")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.10.2.1.box.192.1329.170.29.q.100"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.0.0"
    }
  }), _vm._v("New York")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0.3"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58b6aaf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0006.vue
// module id = 57
// module chunks = 0